const find = (selector, element = document) => [].slice.call(element.querySelectorAll(selector));

const getAncestorWithAttribute = (element, attributeName, attributeValue) => {
  if (element.getAttribute(attributeName) === attributeValue) return element;
  return element.parentNode && getAncestorWithAttribute(element.parentNode, attributeName, attributeValue);
};

const toggleAllInputs = (element, disabled) => {
  const inputs = find('input, select, textarea', element);
  inputs.forEach(input => {
    if (disabled || getAncestorWithAttribute(input, 'data-component', 'FormConditionalBlock') === element) {
      input.disabled = disabled;
    }
  });
};

const handleElementDisplay = (element, show = false) => {
  if (show) {
    element.style.display = '';
    toggleAllInputs(element, false);
  } else {
    element.style.display = 'none';
    toggleAllInputs(element, true);
  }
};

const handleCheckboxChange = (element, fields, values) => () => {
  handleElementDisplay(element, fields.filter(field => field.checked).some(field => values.includes(field.value)) || (values.length === 0 && fields.some(field => field.checked)));
};

const handleSelectChange = (element, field, values) => () => {
  const selected = [];
  for (let i=0; i < field.options.length; i++) {
    if (field.options[i].selected) {
      selected.push(field.options[i].value);
    }
  }
  const selectedAndInValues = values.filter(value => selected.indexOf(value) > -1);
  handleElementDisplay(element, selectedAndInValues.length > 0 || (values.length === 0 && !!field.value));
};

const handleRadioChange = (element, field, values) => () => {
  handleElementDisplay(element, values.includes(field.value) || values.length === 0);
};

export default el => {
  const fieldName = el.dataset.conditionfield || null;
  const values = el.dataset.conditionvalue && el.dataset.conditionvalue.split(',') || [];

  if (fieldName) {
    const fields = find(`[name="${fieldName}"], [name="${fieldName}[]"]`);
    const initialTriggered = false;

    fields.filter(field => field.tagName === 'SELECT').forEach(field => {
      field.addEventListener('change', handleSelectChange(el, field, values));
      handleSelectChange(el, field, values)();
    });

    fields.filter(field => field.type === 'checkbox').forEach(field => {
      field.addEventListener('change', handleCheckboxChange(el, fields, values));
      if (!initialTriggered) {
        handleCheckboxChange(el, fields, values)();
      }
    });

    fields.filter(field => field.type === 'radio').forEach(field => {
      field.addEventListener('change', handleRadioChange(el, field, values));
      if (field.checked) {
        handleRadioChange(el, field, values)();
      }
    });
  }
};
